import { fromJS } from 'immutable';
const initialState = fromJS({
  errorString: '',
});
const errorReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'CLEAR_CONTRACTING_ERROR_STRING':
      return state.set('errorString', '');
    case 'SHOW_CONTRACTING_ERROR_STRING':
      return state.set('errorString', payload);
    default:
      return state;
  }
};

export default errorReducer;



// WEBPACK FOOTER //
// ./src/app/stores/contracting/error-reducer.js